import templateUrl from 'emun.invoice/invoice-heading.htm'

export default {
    bindings: {
        invoice: '<',
    },
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};